/**
 * Converts a name into initials for avatar display.
 *
 * @example
 * NameToInitials("John Doe") // "JD"
 * NameToInitials("Andrew") // "AN"
 * NameToInitials("A") // "AA"
 */
export default function NameToInitials(name: string): string {
    if (!name) {
        return "";
    }

    const words = name.trim().split(" ");
    const firstWord = words[0];

    if (!firstWord || firstWord.length === 0) {
        return "";
    }

    const firstChar = firstWord[0] as string;

    if (words.length > 1 && words[1] && words[1].length > 0) {
        return (firstChar + words[1][0]).toUpperCase();
    }

    if (firstWord.length > 1) {
        return (firstChar + firstWord[1]).toUpperCase();
    }

    return (firstChar + firstChar).toUpperCase();
}
